<template>
    <div>
        <v-toolbar flat color="white">
            <v-toolbar-title>Administrar Fechas</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark class="mb-2" v-on="on">Nueva fecha</v-btn>
                </template>
                <v-card>
                    <v-card-title>
                        <span v-show="!editingSignDate" class="headline">Nueva Fecha Firma Documentos</span>
                        <span v-show="editingSignDate" class="headline">Editar Fecha Firma Documentos</span>
                    </v-card-title>

                    <v-card-text>
                        <select-input
                            :form="form"
                            :items="documentTypes"
                            label="Tipo de documento"
                            :v-errors="errors"
                            :value.sync="form.type"
                            name="type"
                            v-validate="'required'"
                        ></select-input>

                        <date-picker
                            :form="form"
                            :label="'Fecha inicial'"
                            :v-errors="errors"
                            :value.sync="form.start_date"
                            name="start_date"
                            v-validate="'required'"
                        ></date-picker>
                        <has-error :form="form" field="start_date"></has-error>

                        <date-picker
                            :form="form"
                            :label="'Fecha final'"
                            :v-errors="errors"
                            :value.sync="form.finish_date"
                            name="finish_date"
                            v-validate="'required'"
                        ></date-picker>

                        <text-input
                            :form="form"
                            :label="'Periodo'"
                            :v-errors="errors"
                            :value.sync="form.contract_period"
                            name="contract_period"
                            v-validate="'required'"
                        ></text-input>

                        <text-area-input
                            :form="form"
                            :label="'Descripción'"
                            :v-errors="errors"
                            :value.sync="form.description"
                            name="description"
                            v-validate="'required'"
                        ></text-area-input>

                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="close">Cancelar</v-btn>
                        <v-btn v-if="!editingSignDate" color="blue darken-1" flat @click="saveSignDate">Guardar</v-btn>
                        <v-btn v-else color="blue darken-1" flat @click="updateSignDate">Actualizar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-toolbar>
        <v-data-table
          class="the-table"
          :headers="headers"
          :items="sign_dates"
          :pagination.sync="pagination"
          :search="search"
          :loading="loadingTable"
          :rows-per-page-text="$t('datatable.rowsPerPageText')"
          :no-results-text="$t('datatable.noResultsText')"
          :no-data-text="$t('datatable.noDataText')"
          :rows-per-page-items="[10,20,50,{'text':$t('datatable.allRowsPerPageItems'),'value':-1}]"
        >
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">{{ props.item.type == 'EMP' ? 'Empleado' : props.item.type == 'FML' ? 'Familias' : 'Estudiantes' }}</td>
                <td class="text-xs-center">{{ props.item.start_date }}</td>
                <td class="text-xs-center">{{ props.item.finish_date }}</td>
                <td class="text-xs-center">{{ props.item.contract_period }}</td>
                <td class="text-xs-center">{{ props.item.description }}</td>
                <td class="text-xs-center">
                  <v-checkbox
                    :key="props.item.id"
                    :name="`check_${props.item.id}`"
                    :input-value="props.item.status"
                    @change="handleSignDateStatus(props.item.id, props.item.status, props.item.type)"
                    color="primary"
                    class="mt-2 center"
                  ></v-checkbox>
                </td>
                <td class="text-xs-center">
                  <v-tooltip top>
                      <v-icon
                        medium
                        class="mr-2"
                        @click="showSignDateEmployees(props.item.id, props.item.type)"
                        slot="activator"
                      >
                        people
                      </v-icon>
                    <span v-if="props.item.type == 'EMP'" >Empleados</span>
                    <span v-else-if="props.item.type == 'FML'" >Familias</span>
                    <span v-else >Estudiantes</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <v-icon
                      medium
                      class="mr-2"
                      @click="editSignDate(props.item.id)"
                      slot="activator"
                    >
                      edit
                    </v-icon>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <v-icon
                      medium
                      class="mr-2"
                      @click="deleteSignDate(props.item.id)"
                      slot="activator"
                    >
                      delete
                    </v-icon>
                    <span>Eliminar</span>
                  </v-tooltip>
                </td>
            </template>
            <template v-slot:pageText="props">
              {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
            </template>
        </v-data-table>
    <v-dialog v-model="dialogInfo" persistent max-width="900px" width="auto">
      <v-card>
        <v-card-title>
          <span class="headline">{{ infoTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>

            <v-layout row>
              <v-flex xs12>

              <v-data-table
                :headers="signDocumentsHeaders"
                :items="infoItems"
                :search="infoSearch"
              >
              <template  slot="items" slot-scope="props">
                <td class="text-xs-center">{{ props.item.name }}</td>
                <td class="text-xs-center">{{ props.item.vista_document_id }}</td>
                <td class="text-xs-center">
                  <v-icon
                    small
                    @click="deleteDocument(props.item.id)"
                  >
                    delete
                  </v-icon>
                </td>
              </template>
            </v-data-table>
              </v-flex>
          </v-layout>

          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialogInfo = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import Form from 'vform';

export default {
  name: 'documents-sign-date-view',
  data() {
    return {
      headers: [
        { text: 'Tipo Doc', align: 'center', value: 'type' },
        { text: 'Fecha inicio', align: 'center', value: 'start_date' },
        { text: 'Fecha fin', align: 'center', value: 'finish_date' },
        { text: 'Periodo', align: 'center', value: 'contract_period' },
        { text: 'Descripción', align: 'center', value: 'description' },
        { text: 'Estado', align: 'center', value: 'status' },
        { text: 'Acciones', align: 'center', value: 'start_date', sortable: false }
      ],
      sign_dates: [],
      editedIndex: -1,
      isLoading: false,
      loadingTable: false,
      dialog: false,
      pagination: {
          sortBy: 'last_name'
        },
      form: new Form({
        start_date: '',
        finish_date: '',
        description: '',
        contract_period: '',
        status: false,
        type: '',
      }),
      showSucessMessage: false,
      documentsHeaders: [
        { text: 'Documento', align: 'center', value: 'name' },
        { text: 'ID Documento', align: 'center', value: 'vista_document_id' },
        { text: 'Acciones', align: 'center', value: 'required_next_step' }
      ],
      signDocumentsHeaders: [
        { text: 'Documento', align: 'center', value: 'name' },
        { text: 'ID Documento', align: 'center', value: 'vista_document_id' },
        { text: 'Acciones', align: 'center', value: 'required_next_step' }
      ],
      documentTypes: [
        { value: 'EMP', text: 'Empleados' },
        { value: 'FML', text: 'Familias' },
        { value: 'STU', text: 'Estudiantes' },
      ],
      infoItems: [],
      infoSearch: '',
      search: '',
      dialogInfo: false,
      infoTitle: '',
      documentsInfo: true,
      editingSignDate: false,
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  },
  created() {
    this.getSignDatesList()
  },
  methods: {
    async getSignDatesList() {
      this.loadingTable = true;
      const { data } = await axios.get('/api/documents/sign_dates')
      this.sign_dates = data;
      this.loadingTable = false;
    },
    close() {
      this.form.clear();
      this.form.reset();
      this.dialog = false
    },
    async saveSignDate() {
      if (this.form.start_date > this.form.finish_date) {
        this.form.errors.set({
          start_date: "La fecha inicial no puede ser mayor que la final"
        })

        return
      }


      if (await this.formHasErrors()) return

      // let datesAreValid = true;
      // this.sign_dates.forEach(enrollment => {
      //   if (
      //     (Date.parse(`${this.form.start_date} 00:00:00`) > Date.parse(`${enrollment.start_date}`) &&
      //     Date.parse(`${this.form.start_date} 00:00:00`) < Date.parse(`${enrollment.finish_date}`)) ||
      //     (Date.parse(`${this.form.finish_date} 00:00:00`) > Date.parse(`${enrollment.start_date}`) &&
      //     Date.parse(`${this.form.finish_date} 00:00:00`) < Date.parse(`${enrollment.finish_date}`))
      //   ) {
      //     datesAreValid = false
      //   }
      // })

      // if (!datesAreValid) {
      //   this.form.errors.set({
      //     start_date: "Las fechas seleccionadas se cruzan con las de otra matricula creada."
      //   })
      //   return
      // }

      const result = await this.form.post('/api/documents/sign_date', this.form)

      if (result.status === 200) {
        this.getSignDatesList()
        this.$store.dispatch('responseMessage', {
          type: 'success',
          text: 'Fecha creada correctamente',
          modal: false
        })
      }

      this.close()

    },
    deleteDocument(id) {
      axios.delete(`/api/enrollment/document/${id}`)
        .then(resp => {
          if (resp.status === 200) {
            this.showSignDocuments(resp.data.id_enrollment);
            this.$store.dispatch('responseMessage', {
              type: 'success',
              text: this.$t('sign_dates.create-form.document-cost-modal.document-deleted'),
              modal: false
            })
          }
        })
        .catch(error => console.log(error))
    },
    editSignDate(id_enrollment) {
      const enrollmentToEdit = this.sign_dates.filter(enrollment => enrollment.id === id_enrollment)[0];
      this.editingSignDate = true;
      this.dialog = true;
      this.form = new Form({
        start_date: enrollmentToEdit.start_date,
        finish_date: enrollmentToEdit.finish_date,
        description: enrollmentToEdit.description,
        contract_period: enrollmentToEdit.contract_period,
        id: enrollmentToEdit.id,
        type: enrollmentToEdit.type
      });
    },
    deleteSignDate(id_enrollment) {
      axios.delete(`/api/documents/sign_date/${id_enrollment}`)
        .then(resp => {
          if (resp.status === 200) {
            this.sign_dates = this.sign_dates
              .filter(enrollment => enrollment.id !== id_enrollment);
          }
        })
        .catch(error => console.log(error));
    },
    updateSignDate() {

      if (this.form.start_date > this.form.finish_date) {
        this.form.errors.set({
          start_date: "La fecha inicial no puede ser mayor que la final"
        })

        return
      }

      this.form.put('/api/documents/sign_date')
        .then(resp => {
          if (resp.status === 200) {
            this.getSignDatesList()
            this.dialog = false;
            this.editingSignDate = false;
            this.form = new Form({
              start_date: '',
              finish_date: '',
              description: '',
              contract_period: '',
              type: '',
            })
          }
        })
        .catch(error => console.log(error));
    },
    handleSignDateStatus(id_sign_date, status, type) {
      axios.put('/api/documents/sign_date/status', { id: id_sign_date, status: !status, type })
        .then(resp => {
          if (resp.status === 200) {
            this.getSignDatesList()
          }
        })
    },
    showSignDateEmployees(idSignDate, type) {
      let endUrl = 'employees';
      if (type == 'STU') {
        endUrl = 'students'
      }
      if (type == 'FML') {
        endUrl = 'families'
      }
      this.$router.push(`/documents/sign_date/${idSignDate}/${endUrl}`)
    }
  }
}
</script>
<style>
  .center {
    text-align: center;
    vertical-align: middle;
    justify-content: center;
    align-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/documents/sign_date.vue